<template>
  <component-create />
</template>

<script>
import ComponentCreate from './../components/ComponentCreate'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'ComponentEditView',
  components: {
    ComponentCreate
  },
  created () {
    this.find(this.$route.params.uuid).then(() => {
      this.setEditable(this.$route.params.uuid)
    })
  },
  methods: {
    ...mapActions('component', [
      'find'
    ]),
    ...mapMutations('component', {
      setEditable: 'SET_NEW'
    })
  }
}
</script>
